module.exports = __webpack_public_path__ + "static/img/avatar.9dc593ef.png";